import { render, staticRenderFns } from "./Tab.vue?vue&type=template&id=4f223ecb&scoped=true"
import script from "./Tab.vue?vue&type=script&lang=js"
export * from "./Tab.vue?vue&type=script&lang=js"
import style0 from "../../theme/tab.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Tab.vue?vue&type=style&index=1&id=4f223ecb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f223ecb",
  null
  
)

export default component.exports